import { Component, Input, OnInit } from '@angular/core';
import {
    trigger,
    state,
    style,
    animate,
    transition,
} from '@angular/animations';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import { User } from 'src/app/models/user.model';

@Component({
    selector: 'u4-cpp-notice',
    templateUrl: './notice.component.html',
    styleUrls: ['./notice.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                opacity: 1,
            })),
            state('closed', style({
                height: '0px',
                opacity: 0,
                padding: 0,
            })),
            transition('open => closed', [
                animate('0.4s')
            ]),
        ])
    ],
})
export class NoticeComponent implements OnInit {
    @Input() url: string;
    @Input() userId: string;
    @Input() name: string;
    @Input() description: string;
    @Input() buttonLabel: string;
    @Input() dontShowMoreLabel: string;
    public hideAlert: boolean;
    public user: User;

    constructor(private store: Store<AppState>) { }

    ngOnInit(): void {
        this.store
            .select((currentState) => currentState.profile)
            .subscribe((profile: User) => {
                this.user = profile;
            });
        try {
            this.hideAlert = JSON.parse(localStorage.getItem(this.user.id + '_' + this.name)) as boolean;
        } catch (e: unknown) {
            if (e instanceof Error) {
                console.error('error LS:', e.message);
            } else {
                console.error('error LS:', e);
            }
        }
    }
    hideAlertHandler() {
        this.hideAlert = true;
    }
    dontShowMoreHandler() {
        try {
            localStorage.setItem(this.user.id + '_' + this.name, JSON.stringify(true));
        } catch (err: unknown) {
            if (err instanceof Error) {
                console.error('Local Storage error', err.message);
            } else {
                console.error('Local Storage error', err);
            }
        }
        this.hideAlert = true;
    }
}
